import React from "react";
import { useNavigate } from "react-router-dom";
import defaultLogo from "../../../../../assets/images/coachTeamLogo.png";
import { openOnRowClick } from '../../../../../utils/rowClick';

export const RosterColumn = ({ title, players = [], loading = false, teamLogo }) => {
  const navigate = useNavigate();

  const handleViewProfile = (player) => {
    if (player && player._id) {
      navigate(`/scout/player/${player._id}`, {
        state: { playerData: player }
      });
    }
  };

  const isTeamSelected = title !== "SELECT A TEAM";

  return (
    <div className="rounded-3xl bg-slate-900/80 p-4 flex flex-col gap-3">
      {/* Team Header with Logo */}
      {isTeamSelected ? (
        <div className="flex items-center gap-3 pb-3 border-b border-slate-700/50">
          <img
            src={teamLogo || defaultLogo}
            alt={title}
            className="w-12 h-12 rounded-full object-cover border-2 border-slate-600 shadow-lg"
          />
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-bold text-white leading-tight break-words">
              {title}
            </h4>
            <p className="text-[10px] text-slate-400 mt-0.5">Team Roster</p>
          </div>
        </div>
      ) : (
        <div className="text-center py-2">
          <h4 className="text-xs font-semibold text-slate-400">
            {title}
          </h4>
        </div>
      )}

      {/* Players List */}
      <div className="flex flex-col gap-2 max-h-72 overflow-y-auto pr-1 custom-scrollbar">
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <div className="w-6 h-6 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : players.length === 0 ? (
          <div className="flex items-center justify-center py-8 text-slate-400 text-xs text-center px-4">
            {!isTeamSelected ? "Select a team from the match above to view roster" : "No players found in this team"}
          </div>
        ) : (
          players.map((p) => (
            <div
              key={p._id || p.id}
              onClick={openOnRowClick(() => handleViewProfile(p))}
              className="cursor-pointer flex items-center justify-between gap-2 rounded-2xl bg-slate-900/60 hover:bg-slate-800/60 transition-colors px-3 py-2"
            >
              <div className="flex items-center gap-2">
                <img
                  src={p.profileImage || p.photo}
                  alt=""
                  className="w-8 h-8 rounded-full border border-slate-500 object-cover"
                />
                <div className="text-[10px] text-slate-200 leading-tight">
                  <div>Name: {p.firstName} {p.lastName}</div>
                  <div>Number: {p.jerseyNumber || 'N/A'}</div>
                  <div>Position: {p.position || 'N/A'}</div>
                </div>
              </div>
              <button
                onClick={() => handleViewProfile(p)}
                className="px-3 py-1 rounded-full border border-slate-300 text-[10px] text-white hover:bg-slate-800 whitespace-nowrap"
              >
                View profile
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
